import { render, staticRenderFns } from "./CommunityImportForm.vue?vue&type=template&id=173eaefd"
import script from "./CommunityImportForm.vue?vue&type=script&lang=js"
export * from "./CommunityImportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports